import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "Corporate & Commercial",
  "Technology & SaaS",
  "Mergers & Acquisitions",
  "Regulatory Compliance",
  "Arbitration",
  "Governance",
  "Insolvency",
  "Real Estate",
];

export default function Ribbon() {
  return (
    <div className="bg-[#F2EFE9] text-[#050A14] py-6 relative z-10" data-testid="marquee">
      <Marquee speed={40} gradient={false}>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-10 text-2xl md:text-4xl font-900 tracking-tightest inline-flex items-center gap-10">
            {w}
            <span className="text-[#D95A41]">/</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
